export default __webpack_public_path__ + "static/media/calendarIcon.f6333fb5.svg";